import {useInjex} from '@injex/react-plugin';
import {UserNotificationsManager} from '../managers/userNotificationsManager.mdl';

export default function useUserNotificationsManager(): UserNotificationsManager {
    const [inject] = useInjex();
    return inject<UserNotificationsManager>('userNotificationsManager');
}
